import { State, Profil, Organization, Contact } from "src/redux/user";
import InstanceAxios from "src/plugins/axiosInstance";

export async function updateProfil(profil) {
  const formattedResponse = toApiProfil(profil);
  const response = await InstanceAxios.put(
    "/client/users/" + profil.id,
    formattedResponse
  );

  const profilResponse: Profil = {
    id: response.data.id,
    firstname: response.data.prenom,
    lastname: response.data.nom,
    email: response.data.mail1,
    phone: response.data.tel1,
    mobile: response.data.tel2
  };
  return profilResponse;
}

export function updatePassword(id, oldPassword, newPassword) {
  return InstanceAxios.put("/client/users/" + id + "/password", {
    mdp_actuel: oldPassword,
    mdp: newPassword
  });
}
/**
 * Convert our User profil response structure to a format api expects
 */
function toApiProfil(profil: Profil) {
  return {
    nom: profil.lastname,
    prenom: profil.firstname,
    mail1: profil.email,
    tel1: profil.phone,
    tel2: profil.mobile
  };
}
export async function fetchUser(): Promise<State> {
  const response = await InstanceAxios.get("/client/me");

  const profil: Profil = {
    id: response.data.id,
    firstname: response.data.prenom,
    lastname: response.data.nom,
    email: response.data.mail1,
    phone: response.data.tel1,
    mobile: response.data.tel2
  };

  const organization: Organization = {
    id: response.data.Societe.id,
    logo: "",
    city: response.data.Societe.ville,
    adress:
      (response.data.Societe.adresse1 || "") +
      " " +
      (response.data.Societe.adresse2 || ""),
    name: response.data.Societe.nom,
    zipCode: response.data.Societe.cp,
    country: response.data.Societe.pays
  };

  const contact: Contact = {
    id: response.data.Vendor.id,
    firstname: response.data.Vendor.prenom,
    lastname: response.data.Vendor.nom,
    email: response.data.Vendor.mail1,
    phone: response.data.Vendor.tel1 || response.data.Vendor.tel2,
    avatar: response.data.Vendor.avatar
  };

  return { profil, organization, contact };
}



// WEBPACK FOOTER //
// ./src/api/user.tsx